export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "ErrorReportingWebWorker.44c376948462d298.js");
}
